import axios from 'axios';
import React from 'react';
import './index.scss';
import { AppContext } from '../App';
import { useHistory } from 'react-router';

const MobileOAuth = () => {
  const { dispatch, successfulExtraction } = React.useContext(AppContext);
  const [error, setError] = React.useState('');
  const history = useHistory();

  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/token/link_token`, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.token) {
          // @ts-ignore
          const plaidLink = Plaid.create({
            token: response.data.token,
            receivedRedirectUri: window.location.href,
            // @ts-ignore
            onSuccess: async (token, metadata) => {
              dispatch({
                type: 'SET_SUCCESSFUL_EXTRACTION',
                payload: {
                  successfulExtraction: true,
                },
              });
            },
            onExit: async () => {
              // Return to the Landing page for any error or exit event from Link.
              dispatch({
                type: 'SET_PAGE',
                payload: {
                  page: 'landing',
                },
              });
              // Reroute the user to /demo without any query parameters
              history.push({
                pathname: '/demo',
              });
            },
            // @ts-ignore
            onEvent: () => {},
          });
          plaidLink.open();
          // Change Link's zIndex so the demo banner can be seen
          const iframes = Array.from(document.getElementsByTagName('iframe'));
          iframes.forEach((iframe) => (iframe.style.zIndex = '2147483646'));
        } else {
          setError(response.data.error);
        }
      });
  }, [dispatch, history]);

  return (
    <div className="Mobile">
      <div className="Mobile__container">
        <div className="Mobile__title">
          {successfulExtraction && 'Thank you!'}
          {error && 'Error while processing. Please go back and try again'}
        </div>
      </div>
    </div>
  );
};

export default MobileOAuth;
